import { configureStore } from '@reduxjs/toolkit';
import rootReducers from '../store/reducers/RootReducers';

const globalStore = configureStore({
  reducer: rootReducers,
  // This ensures the default middleware, including redux-thunk, are included
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(), 
});

export default globalStore;